import { useTranslation } from "react-i18next";
import { Link, Pill, Text } from "@foris/avocado-suite";
import EditableTableCell from "../editable-table-cell";
import styles from "./programmingResourceEditBtn.module.scss";

interface ProgrammingResourceEditBtnProps {
  items: string[];
  onAssign: () => void;
  isReadOnly?: boolean;
  className?: string;
}

const ProgrammingResourceEditBtn = ({
  items,
  onAssign,
  isReadOnly = false,
  className,
}: ProgrammingResourceEditBtnProps) => {
  const { t } = useTranslation();

  if (items.length === 0) {
    if (isReadOnly) {
      return (
        <Text className={styles.programmingResourceEditBtn_emptyText} type="sm">
          {t("programming-edit.resource-edit.without-assignation")}
        </Text>
      );
    }

    return (
      <Link iconLeft="plus" onClick={onAssign}>
        {t("programming-edit.resource-edit.assign")}
      </Link>
    );
  }

  const [first, ...rest] = items;

  return (
    <div className={`${styles.programmingResourceEditBtn} ${className ?? ""}`}>
      <EditableTableCell
        className={styles.programmingResourceEditBtn_label}
        icon={isReadOnly ? "open-eye" : "edit"}
        onClick={onAssign}
      >
        <Text className={styles.programmingResourceEditBtn_labelText}>{first}</Text>
      </EditableTableCell>
      {rest.length > 0 && (
        <Pill className={styles.programmingResourceEditBtn_pill}>{`+${rest.length}`}</Pill>
      )}
    </div>
  );
};

export default ProgrammingResourceEditBtn;
